import Vue from 'vue'
import router from './script/router'
import VueMeta from 'vue-meta'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueCookie from 'vue-cookie'
import Modals from './modals'
import store from './script/vuex'
import axios from 'axios'
import LoadScript from 'vue-plugin-load-script'
import 'jquery'

axios.defaults.baseURL = 'https://whatsapp.v-avtoservice.com/iiko/'
Vue.prototype.$http = axios
// import axios from '@/script/http'

Vue.config.productionTip = false
Vue.use(LoadScript)
Vue.use(Loading)
Vue.use(VueCookie)
Vue.use(VueMeta, {refreshOnceOnNavigation: true})
Vue.component('modals-block', Modals)
/* eslint-disable no-new */
/* eslint-disable handle-callback-err */
new Vue({
  el: '#app',
  metaInfo: {
    title: '— быстро доставляем вкусную еду',
    titleTemplate: 'Ресторан Буржуй %s',
    description: 'description',
    htmlAttrs: {
      lang: 'ru'
    },
    meta: [
    ]
  },
  router,
  store,
  computed: {
    data () {
      return this.$store.getters.data
    },
    basket () {
      return this.$store.getters.basket
    }
  },
  created () {
    /* eslint-disable */
    function uuidv4 () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    }
    if (!Vue.cookie.get('user-token')) {
      Vue.cookie.set('user-token', uuidv4(), {expires: '1Y', domain: window.location.hostname})
    }
    axios.defaults.headers.common['token'] = Vue.cookie.get('user-token')
    axios.interceptors.request.use(config => {
      if (this.loader !== null && this.loader !== undefined) this.loader.hide()
      this.loader = Vue.$loading.show({
        loader: 'dots',
        opacity: 0.8,
        backgroundColor: 'transparent',
        color: '#54BB65',
        isFullPage: true
      })
      return config
    })
    axios.interceptors.response.use(response => {
      if (this.loader !== null && this.loader !== undefined) this.loader.hide()
      return response
    }, err => {
      if (this.loader !== null && this.loader !== undefined) this.loader.hide()
      /*
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          // if you ever get an unauthorized, logout the user
          this.$store.dispatch('AUTH_LOGOUT')
          // you can also redirect to /login if needed !
        }
        throw err
      })
      */
    })
    this.$store.dispatch('initData')
  },
  mounted () {
    /*
    window.onscroll = () => {
      if (window.pageYOffset > $('.index-header').height()) {
        $('.index-header').addClass('header-fixed')
      } else {
        $('.index-header').removeClass('header-fixed')
      }
    }
    */
    $(document).on('click', '.nav__btn', function () {
      $('.nav').toggleClass('nav__block')
      $('.nav__list').toggleClass('list__block')
    })
    $(document).on('click', '.nav__item--city', function (event) {
      event.preventDefault()
      $('.city__list').toggleClass('list__block')
      $(this).toggleClass('city__bg')
    })
    $(document).on('click', '#enter', function (event) {
      event.preventDefault()
      $('.popup-auth').addClass('pos-fixed')
      $('.overlay').addClass('overlay-bl').on('click', function () {
        $('.popup-auth').removeClass('pos-fixed')
        $(this).removeClass('overlay-bl')
        $('.popup-sms').removeClass('pos-fixed')
      })
      $('.auth-close').on('click', function (event) {
        event.preventDefault()
        $('.popup-auth').removeClass('pos-fixed')
        $('.overlay').removeClass('overlay-bl')
      })
      $('.auth-next').on('click', function (event) {
        event.preventDefault()
        $('.popup-auth').removeClass('pos-fixed')
        $('.popup-sms').addClass('pos-fixed')
      })
      $('.sms-close').on('click', function (event) {
        event.preventDefault()
        $('.overlay').removeClass('overlay-bl')
        $('.popup-sms').removeClass('pos-fixed')
      })
    })
  },
  methods: {
    slideTo (id) {
      $('html, body').animate({scrollTop: ($('#' + id).offset().top - $('header').height() - $('#' + id + ' h2').height() - 48)}, 1000)
    },
    translit (str) {
      var min = 1072
      var max = 1105

      const ru = ['a', 'b', 'v', 'g', 'd', 'e', 'j', 'z', 'i', 'i', 'k', 'l', 'm', 'n', 'o', 'p', 'r', 's', 't', 'u', 'f', 'h', 'c', 'ch', 'sh', 'shch', '', 'y', '', 'e', 'u', 'ya', '', 'yo']
      let translate = ''

      for (let i = 0; i < str.length; i++) {
        const charCode = str[i].toLowerCase().charCodeAt(0)
        if (charCode >= min && charCode <= max) {
          let newChar = ru[charCode - min]
          if (str[i] === str[i].toUpperCase()) {
            if (newChar.length > 1) {
              newChar = newChar.split('').reduce((prev, next, index) => {
                if (index === 1) {
                  return prev.toUpperCase() + next
                } else {
                  return prev + next
                }
              })
            } else {
              newChar = newChar.toUpperCase()
            }
          }
          translate += newChar
        } else {
          translate += str[i]
        }
      }
      return translate.replace(/\s+/g, '')
    }
  }
})
let loader
router.beforeEach((to, from, next) => {
  if (to.name) {
    loader = Vue.$loading.show({
      loader: 'dots',
      opacity: 0.8,
      backgroundColor: 'transparent',
      color: '#54BB65',
      isFullPage: true
    })
  }
  next()
})

router.afterEach(() => {
  if (loader) loader.hide()
})



// WEBPACK FOOTER //
// ./src/main.js